import React from 'react';
import Stub from 'pages/Stub';

class Error404 extends React.Component {
  render() {
    return <Stub heading="404 Error"/>
  }
}
export default Error404;
